import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-support-desk-layout',
  templateUrl: './support-desk-layout.component.html',
  styleUrls: ['./support-desk-layout.component.css']
})
export class SupportDeskLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
